/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component, Fragment } from 'react'
import RxChooseTypeEmoji from '../../../../components/shares/rxChooseTypeEmoji'
import translate from '../../../../classes/lang'

const { REACTIONS } = global.rootRequire('global/obj/global')

const { rxgetLocal, rxsetLocal } = global.rootRequire('classes/request')
const { rxaget, timeConverter, rxChangeSlug, stringToColour, idToColor, formatBytes, secondToTime, rxconfig, changeColorSVG, getExtension, subString } = global.rootRequire('classes/ulti')
const { checkAvatarSender, checkName, checkIsOwner, parseMessageDesc, checkNameUser, checkNameGroup, getDeleteMessStr, checkBlock, changeColorAva, textAva } = global.rootRequire('classes/chat')
const worker = global.rootRequire('classes/globalUser')
const chatDB = global.rootRequire('classes/indexedDB').default

let zget = global.rxu.get

class MessageItem extends Component {
  _isMounted = false
  constructor(props, context) {
    super(props, context)
    this.state = {
      currentEmoTypeClicked: null,
      onOffBgEmoji: true,
      pathImg: './images/sticker',
      arrTabsDisplay: props.arrTabsDisplay || []
    }

    let dataSticker = global.rxu.json(rxgetLocal('rxsticker'), {})
    if (dataSticker.pathimg) {
      this.state.pathImg = dataSticker.pathimg
    }

    this.currentMsg = {}
    this.checkLink = {}
    this.lastSeenMessId = zget(props, 'lastSeenMess', '')
    this.urllinkId = ''
    this.messStatus = 0
    this.userid = this.props.userid
    this.choosePoll = this.choosePoll.bind(this)
    this.users = rxaget(this.props, 'users', {})
  }
  componentDidMount() {
    window.choosePoll = this.choosePoll
  }
  componentWillUnmount() {
    window.choosePoll = null
  }
  shouldComponentUpdate(nextProps, nextState) {
    try {
      if (
        zget(nextProps.currentMsg, 'message_id', '') === zget(this.currentMsg, 'message_id', '') ||
        zget(nextProps.currentMsg, 'status', '') === zget(this.currentMsg, 'status', '') ||
        zget(nextProps.currentMsg, 'type', '') === zget(this.currentMsg, 'type', '')
      ) {
        let group_id = this.props.group_id
        if (zget(nextProps, 'lastSeenMess', '') !== this.lastSeenMessId && Number(zget(nextProps, 'lastSeenMess', '')) >= Number(zget(this.currentMsg, 'message_id', '')) && Number(this.lastSeenMessId) < Number(zget(this.currentMsg, 'message_id', ''))) {
          this.lastSeenMessId = zget(nextProps, 'lastSeenMess', '')
          return true
        } else if (nextProps.netaLink && nextProps.netaLink.uid && this.urllinkId !== nextProps.netaLink.uid) {
          this.urllinkId = nextProps.netaLink.uid
          return true
        } else if (nextProps.arr[this.props.index - 1] && nextProps.currentMsg.sender_uin === nextProps.arr[this.props.index - 1].sender_uin && nextProps.arr[this.props.index - 1]['status'] === 4) {
          if (nextProps.currentMsg && nextProps.arr[this.props.index] && ((nextProps.currentMsg.status !== nextProps.arr[this.props.index].status) || (nextProps.currentMsg.status !== this.currentMsg.status) || (!nextProps.arr[this.props.index + 1] && this.currentMsg.status === 4))) {
            return true
          } else {
            return false
          }
        } else if (nextProps.currentMsg.status !== this.currentMsg.status) {
          return true
        } else if (nextProps.flagShowAva !== this.props.flagShowAva) {
          return true
        } else if ((nextProps.currentMsg && nextProps.arr[this.props.index] && nextProps.currentMsg.status !== nextProps.arr[this.props.index].status) || ((nextProps.currentMsg && nextProps.currentMsg.deleted_uins && nextProps.arr[this.props.index] && nextProps.arr[this.props.index]['deleted_uins']) && (nextProps.currentMsg.deleted_uins.length !== nextProps.arr[this.props.index]['deleted_uins'].length))) {
          return true
        } else if (rxaget(nextProps, 'group.occupants_uins', []).length !== rxaget(this.props, 'group.occupants_uins', []).length) {
          return true
        } else if (this.currentMsg.status !== this.messStatus) {
          this.messStatus = this.currentMsg.status
          return true

        } else if (this.state.onOffBgEmoji != nextState.onOffBgEmoji) {
          return true

        } else if (this.state.currentEmoTypeClicked != nextState.currentEmoTypeClicked || this.props.currentMessageIdClicked != nextProps.currentMessageIdClicked) {
          return true

        } else if (JSON.stringify(this.props.reactions) != JSON.stringify(nextProps.reactions)) {
          return true

        } else if (nextProps.currentMsg.type === 6) {
          this.users = rxaget(nextProps, 'users', {})

          return true

        } else if ((zget(nextProps, 'keywords', '') !== '' || zget(this.props, 'keywords', '') !== '') && nextProps.keywords !== this.props.keywords) {
          return true
        } else {
          return false
        } //else if (nextProps.strMessage.length !== this.props.strMessage.length) {
        //   return true
        // }      

      } else {
        return true
      }
    } catch (e) {
      return true
    }
  }

  onClickTypeEmoji = (type, msgId) => {
    if (!this.state.currentEmoTypeClicked) {

    }
    this.setState({ currentEmoTypeClicked: type, onOffBgEmoji: !this.state.onOffBgEmoji })
    this.props.onClickEmoji(msgId)
  }

  onClickBg = () => {
    this.setState({ onOffBgEmoji: !this.state.onOffBgEmoji, currentEmoTypeClicked: null })
  }

  parseMessage(objmsg, type) {
    let message = ''
    let attachments = {}
    this.userid = this.props.userid.toString()
    const userid = this.userid.toString()
    if (objmsg) {
      if (!isNaN(objmsg.type)) {
        try {
          attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, '').replace(/\\/g, '\\\\'))
        } catch (e) {
          try {
            attachments = JSON.parse(rxaget(objmsg, 'attachments', '').replace(/[\t\r\n]/g, ''))
          } catch (e2) {
            if (typeof (rxaget(objmsg, 'attachments', '')) === 'object') {
              attachments = rxaget(objmsg, 'attachments', '')
            }
          }
        }
        if (objmsg.status !== 4) {
          if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
            message = this.getDeleteMessStr(objmsg, this.users, this.userid)
          } else {
            let mess = ''
            switch (objmsg.type) {
              case -1:
                message = translate('Unread Messages')
                break
              case 1:
                let call_name = ''
                let icon_call_name = ''
                if (attachments.media_type === 1) {
                  call_name = translate('Voice call')
                  icon_call_name = 'icon-phone'
                } else if (attachments.media_type === 2) {
                  call_name = translate('Video call')
                  icon_call_name = 'icon-camrecorder'
                }
                let iconcall = ''
                let stylecall = ''
                if (rxaget(attachments, 'caller_uin', '') === this.userid.toString()) {
                  iconcall = 'icon-call-out'
                  if (zget(this.props, 'themeValue') === 'blueColor') {
                    stylecall = '#fdf2ea'
                  } else {
                    if (rxconfig.theme === 'galo') {
                      stylecall = '#d4f5f1'
                    } else if (rxconfig.theme === 'default') {
                      stylecall = '#e5efff'
                    }
                  }
                } else {
                  iconcall = 'icon-call-in'
                  if (zget(this.props, 'themeValue') === 'blueColor') {
                    stylecall = '#fdf2ea'
                  } else {
                    if (rxconfig.theme === 'galo') {
                      stylecall = '#d4f5f1'
                    } else if (rxconfig.theme === 'default') {
                      stylecall = '#e5efff'
                    }
                  }
                }
                message = `<div class='zchat-callmess' style='background: ${stylecall};'>
                  <div class='zchat-callname'>${call_name}</div>`
                if (attachments.accepted_at === '0') {
                  message += `<div class='zchat-calltime' style='color:#d5192d;'><i class='${iconcall}'></i>${(attachments.caller_uin.toString() === this.userid.toString()) ? translate('Canceled') : translate('Missed')}</div>`
                } else {
                  const time = Number(rxaget(attachments, 'stopped_at', 0)) - Number(rxaget(attachments, 'accepted_at', 0))
                  message += `<div class='zchat-calltime'><i class='${iconcall}' style='color:#2fb13e;'></i>${secondToTime(time)}</div>`
                }
                message += `<span class='zchat-callicon'><i class='${icon_call_name}'></i></span></div>`
                if (type === 'desc') {
                  mess = translate(' finished')
                  message = call_name + mess
                }
                break
              case 2:
                try {
                  if (attachments && attachments.images && attachments.images.constructor === Array && attachments.images.length > 0) {
                    let arrurlimgs = rxaget(attachments, 'images', []).map(o => o.url)
                    let strurlimgs = (arrurlimgs && arrurlimgs.constructor === Array && arrurlimgs.length > 0) ? arrurlimgs.join(',') : ''
                    message = `<div> <div></div> <div class="img-message-row" id=${objmsg.message_id}>`
                    let indeximg = 0
                    let imgHeight = 0
                    for (const img of attachments.images) {
                      if (!attachments.loading) {
                        if (img.height >= 360 && img.width >= 240) {
                          switch (img.height / img.width) {
                            case 1.5:
                              imgHeight += 360
                              break;
                            case 1:
                              imgHeight += 240
                              break;
                            default:
                              if (img.height / img.width > 1.5) {
                                imgHeight += 360
                              }
                              if (img.height / img.width < 1.5) {
                                let imgHeightTmp = 240 * (img.height / img.width)
                                if (imgHeightTmp >= 360) {
                                  imgHeight += 360
                                } else {
                                  imgHeight += imgHeightTmp
                                }
                              }
                          }
                        } else {
                          if (img.height >= 360) {
                            imgHeight += 360
                          } else {
                            if (img.width >= 240) {
                              imgHeight += 240 * (img.height / img.width)
                            } else {
                              imgHeight += img.height
                            }

                          }

                        }
                      }
                      if (attachments.loading)
                        message += `<img class='zchat-mess-cancel-btn' alt='icon-cancel-btn' onclick=window.cancleUpload('${objmsg.message_id}','${img.url}') src='./images/default/icons/icon-cancel-btn.svg'/><div class="loading"></div>`

                      let strImgForward = img.url + '|' + (img.width || 0) + '|' + (img.height || 0)
                      message += `<img src='${((!attachments.loading ? global.rxu.config.get_static : "") + img.url)}' alt='' class='${!objmsg.message ? "img-message" : "img-message message-offborder"}' onclick=window.showGallery('${strurlimgs}','${indeximg}') onmousedown="window.getGallery('${strImgForward}','${indeximg}')" />`
                      indeximg += 1
                    }
                    message += '</div></div>'

                    if (objmsg.message) {
                      let messagetmp = this.convertUrlMess(objmsg, type)
                      if (this.userid.toString() === objmsg.sender_uin.toString()) {
                        message += `<span class='img-message-text'>${messagetmp}</span>`
                      } else {
                        message += `<span class='img-message-text img-message-text-another'>${messagetmp}</span>`
                      }

                    }

                    if (!(type === 'lastpin' || attachments.loading))
                      message = message.replace('class="img-message-row"', 'class="img-message-row"style="height:' + imgHeight + 'px;"')
                    if (type === 'desc') {
                      message = translate('Image')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break
              case 3:
                let audio = (attachments && attachments.audio) || objmsg.audio
                const url = rxaget(audio, 'url', '')
                const src = global.rxu.config.get_static + url
                message = `<div class='zchat-audiomess'>`
                let id = objmsg.message_id
                if (objmsg.rpId) id += objmsg.rpId
                message += `
                  <div class='zchat-audioicon filter_img_class' onclick=window.playAudio('icon-audio-${id}')>
                    <img id='icon-audio-${id}'  src='./images/default/static/icon-media-play.svg'/>
                  </div>`

                message +=
                  `
                  <div class='zchat-audiobar'>
                    <div class='zchat-audioprocess' id='process-audio-${id}'>
                    </div>
                  </div>
                  <div class='zchat-audiotime'>
                    ${secondToTime(rxaget(audio, 'duration', 0))}
                  </div>
                `
                message += `
                  <audio id='${'audio-' + id}' >
                    <source id='${'audio' + url}' src='${src}' type='audio/mpeg'/>
                  </audio>
                `
                message += `</div>`
                if (type === 'desc') {
                  message = 'Audio'
                }
                break
              case 4:
                try {
                  if (attachments && attachments.video && attachments.video.url) {
                    const url = attachments.video.url
                    let src
                    // let videoControls = "controls='controls'"
                    let videoControls = 'controls'
                    let videoObj = attachments.video
                    let videoHeight = 241 * (videoObj.height / videoObj.width)

                    message = '<div class="img-message-row">'
                    if (attachments.loading) {
                      src = url
                      message += `<img class='zchat-mess-cancel-btn' alt='icon-cancel-btn' onclick=window.cancleUpload('${objmsg.message_id}','${attachments.video.url}') src='./images/default/icons/icon-cancel-btn.svg'/> <div class="loading"></div>`
                      videoControls = ''
                    } else {
                      src = global.rxu.config.get_static + url
                    }
                    message += `
                        <video class='${!objmsg.message ? "zchat-mess-video" : "zchat-mess-video message-offborder"}' id='${'video' + objmsg.message_id}' height='${videoHeight}' width='320' ${videoControls} preload='metadata'>
                          <source id='${'video' + url}' src='${src}#t=0.1' />
                          Your browser does not support HTML5 video.
                        </video>
                      `
                    if (objmsg.message) {
                      message += `<span class='video-message-text'>${objmsg.message}</span>`
                    }
                    message += '</div>'
                    if (type === 'desc') {
                      message = 'Video'
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break
              case 5:
                if (objmsg.group_type === 4) {
                  mess = translate(' created a channel')
                  message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                } else if (objmsg.group_type !== 3) {
                  mess = translate(' created a group')
                  message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                } else {
                  try {
                    let receiver_uin = objmsg.recipient_uins.filter(uin => uin.toString() != this.userid.toString())
                    if (receiver_uin && receiver_uin.length > 0) {
                      mess = translate('Start chat with ')
                      message = mess + this.checkNameUser(rxaget(this.users, receiver_uin[0].toString(), {}))
                    }
                  } catch (e3) { }
                }

                break
              case 6:
                const userins = []
                try {
                  if (attachments && attachments.added_uins && attachments.added_uins.constructor === Array && attachments.added_uins.length > 0) {
                    for (const uid of attachments.added_uins) {
                      const uname = this.checkNameUser(rxaget(this.users, uid.toString(), {}))
                      if (uname) {
                        userins.push(uname)
                      }
                    }
                  }
                  else if (attachments.removed_uins && attachments.removed_uins.constructor === Array && attachments.removed_uins.length > 0) {
                    let rmMem = []
                    for (const uid of attachments.removed_uins) {
                      const uname = this.checkNameUser(rxaget(this.users, uid.toString(), {}))
                      if (uname) {
                        rmMem.push(uname)
                      }
                    }
                    if (rmMem.length > 0) {
                      mess = translate(' removed ')
                      message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess + rmMem.join(', ')
                    }
                  }
                  else if (attachments.added_admins && attachments.added_admins.constructor === Array && attachments.added_admins.length > 0) {
                    let rmMem = []
                    for (const uid of attachments.added_admins) {
                      const uname = this.checkNameUser(rxaget(this.users, uid.toString(), {}))
                      if (uname) {
                        rmMem.push(uname)
                      }
                    }
                    if (rmMem.length > 0) {
                      mess = translate(' added ')
                      message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess + rmMem.join(', ') + ' ' + translate('to group\'s admins list')
                    }
                  }
                  else if (attachments.deleted_admins && attachments.deleted_admins.constructor === Array && attachments.deleted_admins.length > 0) {
                    let rmMem = []
                    for (const uid of attachments.deleted_admins) {
                      const uname = this.checkNameUser(rxaget(this.users, uid.toString(), {}))
                      if (uname) {
                        rmMem.push(uname)
                      }
                    }
                    if (rmMem.length > 0) {
                      mess = translate(' removed ')
                      message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess + rmMem.join(', ') + ' ' + translate('from group\'s admins list')
                    }
                  }
                  else if (attachments.removed_uin) {
                    message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + translate(' removed ') + this.checkNameUser(rxaget(this.users, attachments.removed_uin.toString(), {}))
                  }
                  else if (attachments.type === 'change_owner' && attachments.owner_uin) {
                    message = (this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + translate(' promoted ')
                      + (this.checkNameUser(rxaget(this.users, (attachments.owner_uin).toString(), {}))) + translate(' to group owner')
                  }
                  else if (attachments.pin_message) {
                    if (attachments.pin_message && attachments.pin_message.type !== 17) {
                      var content = rxaget(attachments, 'pin_message.type', 0) === 0 ? rxaget(attachments, 'pin_message.message', '') : translate(rxaget(attachments, 'pin_message.message', ''))
                      content = content.replace(/\\n\\t/g, " ").replace(/(?<!\\)\\n/g, ' ').replace(/\\\\n/g, "\\n").replace(/\\\\\\n/g, "\\n").replace(/\\\\r/g, "\\r").replace(/\\\\t/g, '\\t').replace(/(?<=[^\w\s]|^)\\t/g, ' ')//.replace(/(\w|\.|,|\?|!| |)\\n/g, "$1 ").replace(/\\\\n/g, "\\n")
                      mess = rxaget(attachments, 'pin_message.message') ? (translate(' pinned') + ' "' + content + '"') : translate(' pinned one message')
                      if (mess.indexOf('[') !== -1) {
                        mess = mess.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<b>$1</b>')
                        mess = mess.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
                        mess = mess.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
                      }
                      message = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}), this.userid, this.user) + mess
                    } else {
                      let attach_mess = attachments.pin_message.message
                      let attachments_poll = attach_mess.attachments
                      let content = ''
                      if (attachments_poll) {
                        content = ' "' + attachments_poll?.question + '"'
                      }
                      mess = translate(' just pinned the poll')
                      let pollMess = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}), this.userid, this.user) + mess + content
                      message = `<div class='zchat-poll-row'  onclick=window.choosePoll(${JSON.stringify(attachments)},${objmsg.type})>` + pollMess + `<span class='zchat-poll-row-text'>${translate(" See")}</span></div>`

                    }
                  }
                  else if (attachments.unpin_message) {
                    if (attachments.unpin_message && attachments.unpin_message.type !== 17) {
                      var content = rxaget(attachments, 'unpin_message.type', 0) === 0 ? rxaget(attachments, 'unpin_message.message', '') : translate(rxaget(attachments, 'unpin_message.message', ''))
                      content = content.replace(/\\n\\t/g, " ").replace(/(?<!\\)\\n/g, ' ').replace(/\\\\n/g, "\\n").replace(/\\\\\\n/g, "\\n").replace(/\\\\r/g, "\\r").replace(/\\\\t/g, '\\t').replace(/(?<=[^\w\s]|^)\\t/g, ' ')
                      mess = rxaget(attachments, 'unpin_message.message') ? (translate(' unpin: ') + ' "' + content + '"') : translate(' unpin one message')
                      if (mess.indexOf('[') !== -1) {
                        mess = mess.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '$1')
                        mess = mess.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '$1')
                        mess = mess.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '$1')
                      }
                      message = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}), this.userid, this.user) + mess
                    } else {
                      let attach_mess = attachments.unpin_message.message
                      let attachments_poll = attach_mess.attachments
                      let content = ''
                      if (attachments_poll) {
                        content = ' "' + attachments_poll?.question + '"'
                      }
                      mess = translate(' just unpinned the poll')
                      let pollMess = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}), this.userid, this.user) + mess + content
                      message = `<div class='zchat-poll-row'  onclick=window.choosePoll(${JSON.stringify(attachments)},${objmsg.type})>` + pollMess + `<span class='zchat-poll-row-text'>${translate(" See")}</span></div>`

                    }
                  }
                  else if (attachments.unpin_all_messages) {
                    message = checkNameUser(rxaget(worker.users, objmsg.sender_uin.toString(), {}), this.userid, this.user) + translate(" unpin all message")

                  }
                  else if (attachments && attachments.updated_group_avatar) {
                    message = (this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + translate(' update avatar')
                  }
                  else if (attachments && attachments.updated_group_name) {
                    message = (this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + translate(' update group name')
                  }
                  else if (attachments && attachments.type === 'update_group' && (attachments.owner_uin || attachments.admin_uins)) {
                    let arrAdmins = rxaget(this.props, 'group.admin_uins', [])
                    let descMess = translate(' change group admin to: ')
                    if (arrAdmins.indexOf(objmsg.sender_uin.toString()) !== -1) {
                      descMess = translate(' add new admin ')
                    }
                    message = (this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + descMess
                      + (this.checkNameUser(rxaget(this.users, (attachments.owner_uin || attachments.admin_uins[0]).toString(), {})))
                  } else if (attachments && attachments.group_id && attachments.push_all && attachments.push_all.constructor === Array && attachments.push_all.length > 0) {
                    try {
                      const arrUserNameAdd = []
                      for (const uid of attachments.push_all) {
                        const unameNew = this.checkNameUser(rxaget(this.users, uid.toString(), {}))
                        if (unameNew) {
                          arrUserNameAdd.push(unameNew)
                        }
                      }
                      if (arrUserNameAdd.length > 0) {
                        message = arrUserNameAdd.join(', ') + translate(' joined group with link')
                      }
                    } catch (e1) { }
                  } else if (attachments && attachments.type === 'update_group') {
                    let groupType = objmsg.group_type
                    let groupName = translate('chat')
                    if (groupType == 4) {
                      groupName = translate('channel')
                    } else if (groupType == 2) {
                      groupName = translate('group')
                    }

                    message = (this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}))) + translate(' update group info') + groupName
                  }
                } catch (e) {
                  console.log(e)
                }
                if (userins.length > 0) {
                  mess = translate(' added ')
                  message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess + userins.join(', ')
                }
                break
              case 7:
                mess = translate(' has left the group')
                message = this.checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                break
              case 8:
                message = '<div class=\'row-reply\'>'
                if (checkIsOwner(objmsg, this.userid)) {
                  message += `<div class='sender-reply'> <span class='sender-reply-span'><img class='filter_img_class' alt='icon-reply' src='${changeColorSVG('./images/default/icons/reply-icon.svg')}'> ${translate('Answer for')} ${this.checkNameUser(rxaget(this.users, attachments.sender_uin, {})) || ''} </span></div>`

                } else {
                  message += `<div class='sender-reply'> <img class='filter_img_class' alt='icon-reply' src='${changeColorSVG('./images/default/icons/reply-icon.svg')}'> ${translate('Answer for')} ${this.checkNameUser(rxaget(this.users, attachments.sender_uin, {})) || ''} </div>`

                }


                if (attachments.type === 8 || attachments.type === 9) {
                  attachments.type = 0
                }
                try {
                  attachments.rpId = objmsg.message_id
                } catch (e5) { }
                let attachments_tmp = this.parseMessage(attachments)
                if (!attachments.type) {
                  attachments_tmp = attachments_tmp.replace(/(?<=[^\w\s]|^)\\t/g, ' ').replace(/\\n\\t/g, '\\n ').replace(/\\t\\n/g, ' \\n')
                }
                if (attachments_tmp !== '') {

                  let message_reply_content_class = ''
                  let file_reply_content_class = ''
                  if (attachments_tmp.indexOf('img-message-row') !== -1 || attachments_tmp.indexOf('zchat-filemess') !== -1 || attachments_tmp.indexOf('zchat-audiomess') !== -1) {
                    file_reply_content_class = ' file-reply_content'

                  }
                  if (attachments_tmp && attachments_tmp.indexOf('\\n') !== -1) {
                    // (?<!\\)\\{2}n
                    attachments_tmp = attachments_tmp.replace(/(?<!\\)\\n/g, '</br>').replace(/\\\\n/g, '\\n')
                  }
                  if (checkIsOwner(objmsg, this.userid)) {
                    message_reply_content_class = 'message-reply_content_right' + file_reply_content_class
                  } else {
                    message_reply_content_class = 'message-reply_content' + file_reply_content_class
                  }

                  message += `
                      <div class='clearfix message-reply'>
                        <div></div>
                        <div class='${message_reply_content_class}''>
                          ${attachments_tmp}
                        </div>
                      </div>`
                } else {
                  if (checkIsOwner(objmsg, this.userid)) {
                    message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content_right' >
                        &nbsp;
                      </div>
                    </div>`
                  }
                  else {
                    message += `
                    <div class='message-reply'>
                      <div></div>
                      <div class='message-reply_content'>
                        &nbsp;
                      </div>
                    </div>`
                  }
                }

                let messagetmpReply = this.convertUrlMess(objmsg, type)
                if (messagetmpReply && messagetmpReply.indexOf('\\n') !== -1) {
                  messagetmpReply = messagetmpReply.replace(/\\n/g, '</br>')
                }
                message += '</div>'
                if (this.userid.toString() === objmsg.sender_uin.toString()) {

                  message += '<div class=\'zmessage-reply-anwser my_message\'>' + messagetmpReply + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div>' || ''
                } else {
                  if (objmsg.message.length === 0) {
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>&#160<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div></div>' || ''
                  }
                  else {
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>' + this.convertTagName(messagetmpReply) + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div> </div></div>' || ''
                  }

                }
                if (type === 'desc') {
                  message = objmsg.message
                }
                break
              case 9:

                let sender_name
                let sender_name_mess = translate('You')
                sender_name = checkIsOwner(attachments, this.userid) ? sender_name_mess : (this.users[objmsg.sender_uin]) ? this.checkNameUser(this.users[objmsg.sender_uin]) : ''
                message = '<div class=\'row-reply\'>'
                if (checkIsOwner(objmsg, this.userid)) {
                  message += `<div class='sender-reply '> <span class='sender-reply-span'><img class='filter_img_class' alt='icon-reply' src='${changeColorSVG('./images/default/icons/forward-icon.svg')}'/> ${sender_name || ''} ${translate('forwarded a message')} </span></div>`

                } else {
                  message += `<div class='sender-reply '> <img class='filter_img_class' alt='icon-reply' src='${changeColorSVG('./images/default/icons/forward-icon.svg')}'/> ${sender_name || ''} ${translate('forwarded a message')} </div>`

                }

                attachments.rpId = objmsg.message_id
                if (attachments.type === 9 || attachments.type === 8) {
                  attachments.type = 0
                }
                let attachments_forward = this.parseMessage(attachments)

                if (!attachments.type) {
                  attachments_forward = attachments_forward.replace(/(\W|^)\\t/g, ' ').replace(/\\n\\t/g, '\\n ').replace(/\\t\\n/g, ' \\n')
                }

                if (attachments_forward !== '') {

                  let message_reply_content_class = ''
                  let file_reply_content_class = ''
                  if (attachments_forward.indexOf('img-message-row') !== -1 || attachments_forward.indexOf('zchat-filemess') !== -1 || attachments_forward.indexOf('zchat-audiomess') !== -1) {
                    file_reply_content_class = ' file-reply_content'

                  }
                  if (checkIsOwner(objmsg, this.userid)) {
                    message_reply_content_class = 'message-reply_content_right' + file_reply_content_class
                  } else {
                    message_reply_content_class = 'message-reply_content' + file_reply_content_class
                  }

                  if (attachments_forward && attachments_forward.indexOf('\\n') !== -1) {
                    attachments_forward = attachments_forward.replace(/(?<!\\)\\n/g, '</br>').replace(/\\\\n/g, '\\n')
                  }

                  message += `
                      <div class='clearfix message-reply'>
                        <div></div>
                        <div class='${message_reply_content_class}''>
                          ${attachments_forward}
                        </div>
                      </div>`
                }
                let messagetmpForward = this.convertUrlMess(objmsg, type)
                if (messagetmpForward && messagetmpForward.indexOf('\\n') !== -1) {
                  messagetmpForward = messagetmpForward.replace(/(?<!\\)\\n/g, '</br>').replace(/\\\\n/g, '\\n')
                }
                message += '</div>'
                if (this.userid.toString() === objmsg.sender_uin.toString()) {
                  if (objmsg.message) {
                    message += '<div class=\'zmessage-reply-anwser my_message\'>' + messagetmpForward + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div>' || ''
                  }
                } else {
                  if (objmsg.message.length === 0) {
                    // message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>&nbsp;</div></div>' || ''
                  } else {
                    message += '<div class=\'zmessage-reply-anwser another_message\'><div class=\'another_message_box\'>' + messagetmpForward + '<div class=\'zmessage_time\'> ' + timeConverter(objmsg.created_at, 'minute') + ' </div></div></div>' || ''
                  }


                }
                if (type === 'desc') {
                  message = objmsg.message
                }
                break
              case 10:
                try {
                  if (attachments && attachments.sticker) {

                    const namesticker = attachments.sticker || ''
                    if (namesticker && typeof (namesticker) === 'string') {
                      let indexPath = namesticker.indexOf('_')
                      let stickerStr = indexPath < 0 ? '' : namesticker.slice(0, indexPath)
                      let imgsticker = indexPath < 0 ? '' : namesticker.slice(indexPath + 1)
                      if (indexPath !== -1) {
                        if (this.checkSticker(stickerStr, imgsticker)) {
                          if (getExtension(attachments.sticker) === 'json') {
                            message = `<lottie-player autoplay loop mode='normal' style='width: 100px; height:100px' src='${this.state.pathImg}/${stickerStr}/${imgsticker}'></lottie-player>`
                          } else {
                            message = `<img src='${this.state.pathImg}/${stickerStr}/${imgsticker}' alt='sticker' class='img-sticker' onerror='this.onerror=null;this.src="./images/tabs/default.jpg";'/>`
                          }
                        } else {
                          message = `<img src='./images/tabs/default.jpg' alt='sticker' class='img-sticker' />`
                        }

                      }

                      break
                    }

                  }
                } catch (e) {
                  console.log(e)
                }
                if (type === 'desc') {
                  message = 'Sticker'
                }
                break
              case 12:
                let file = (attachments && attachments.file) || objmsg.file
                if (file) {
                  let file_name = rxaget(file, 'file_name', '').toString()
                  file_name = file_name.replace(/[\s]/g, '-')
                  let fileNameExt = file_name + '.' + rxaget(file, 'file_extension', '')

                  if (attachments.loading) {
                    message = `<div class="img-message-row" id=${objmsg.message_id}>`
                    message += `<img class='zchat-mess-cancel-btn' alt='icon-cancel-btn' onclick=window.cancleUpload('${objmsg.message_id}','${file.url}') src='./images/default/icons/icon-cancel-btn.svg'/><div class="loading"></div>`
                    message += `<div class='${!objmsg.message ? "zchat-filemess" : "zchat-filemess message-offborder"}'>
                    <div class='zchat-filename'>${rxaget(file, 'file_name', '')}</div>`
                    message += `<div class='zchat-calltime' style='color:#a6a6a7;'>${formatBytes(rxaget(file, 'size', 0))}</div>`
                    message += `<span class='zchat-docicon'><i class='icon-doc'></i></span></div>`
                    message += '</div>'
                  } else {
                    message = `<div class='${!objmsg.message ? "zchat-filemess" : "zchat-filemess message-offborder"}'>
                    <div class='zchat-filename'>${rxaget(file, 'file_name', '')}.${rxaget(file, 'file_extension', '')}</div>`
                    message += `<div class='zchat-calltime' style='color:#a6a6a7;'>${formatBytes(rxaget(file, 'size', 0))}</div>`
                    message += `<span class='zchat-docicon' onclick=window.downloadFile('${rxaget(file, 'url', '').toString()}','${fileNameExt}')><i class='icon-doc'></i></span></div>`
                  }

                  if (objmsg.message) {
                    let messagetmp = this.convertUrlMess(objmsg, type)
                    if (this.userid.toString() === objmsg.sender_uin.toString()) {
                      message += `<span class='file-message-text'>${messagetmp}</span>`
                    } else {
                      message += `<span class='file-message-text img-message-text-another'>${messagetmp}</span>`
                    }
                  }

                  if (type === 'desc') {
                    message = translate('File')
                  }
                }
                break
              case 14:
                try {
                  if (attachments && attachments.location) {
                    message = `<div> <div></div> <div class="img-message-row" id=${objmsg.message_id}>`
                    let imgHeight = 240

                    if (attachments.location && attachments.location.image_url) {
                      let linkMap = ''
                      if (rxaget(attachments, 'location.lat', 0) && rxaget(attachments, 'location.long', 0)) {
                        linkMap = `https://www.google.com/maps/search/?api=1&query=${rxaget(attachments, 'location.lat', 0)},${rxaget(attachments, 'location.long', 0)}`
                      }
                      message += `<img src='${(global.rxu.config.get_static + attachments.location.image_url)}' alt='' class='img-message' onclick=window.openExternalLink('${linkMap}') />`
                    }


                    message += '</div></div>'
                    if (!(type === 'lastpin' || attachments.loading))
                      message = message.replace('class="img-message-row"', 'class="img-message-row" style="height:' + imgHeight + 'px;"')
                    if (type === 'desc') {
                      message = translate('Position')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break
              case 15:
                try {
                  if (attachments) {
                    message = `<div> <div></div> <div class="img-message-row" id=${objmsg.message_id}>`
                    let imgHeight = 240

                    if (attachments.image_url) {
                      let linkMap = ''
                      if (rxaget(attachments, 'latitude', 0) && rxaget(attachments, 'longitude', 0)) {
                        linkMap = `https://www.google.com/maps/search/?api=1&query=${rxaget(attachments, 'latitude', 0)},${rxaget(attachments, 'longitude', 0)}`
                      }

                      message += `<img src='${(global.rxu.config.get_static + attachments.image_url)}' alt='' class='img-message' onclick=window.openExternalLink('${linkMap}') />`
                    }

                    let endTime = (attachments.ended_at) ? Number(attachments.ended_at) : 0
                    let currentTime = Math.floor(Date.now() / 1000)
                    let flagTime = endTime - currentTime

                    if (flagTime > 0) {
                      let strTime = ''
                      let percentTime = 0

                      if (flagTime < 60) {
                        strTime = flagTime + 's'
                      } else if (flagTime >= 60 && flagTime < 3600) {
                        strTime = Math.floor(flagTime / 60) + 'm'
                      } else if (flagTime > 3600) {
                        strTime = Math.floor(flagTime / 3600) + 'h'
                      }

                      if (attachments.duration && !isNaN(attachments.duration) && Number(attachments.duration) > flagTime) {
                        percentTime = parseFloat((100 - ((flagTime / Number(attachments.duration)) * 100)).toFixed(2))
                      }
                      let degCircle = Math.floor((360 / 100) * percentTime)
                      let rightTime = (percentTime < 50) ? degCircle : 180
                      let clipStr = (percentTime > 50) ? 'clip: rect(auto, auto, auto, auto);' : ''
                      let leftTime = (percentTime > 50) ? 'transform:rotate(' + degCircle + 'deg);' : 'display:none'

                      message += `<div class='position-message-row'>
                        <span class='position-record-point'></span>
                        <div class='position-desc'>
                          <div>Đang chia sẻ hành trình</div>
                          <div class='zlocation_desc'>Cập nhật liên tục</div>
                        </div>
                        <div class='position-timer-process'>
                          <div class='position-pie-wrapper'>
                            <span class='position-label'>${strTime}</span>
                            <div class='position-pie' style='${clipStr}'>
                              <div class='position-half-circle' style='${leftTime}'></div>
                              <div class='position-half-circle' style='transform:rotate(${rightTime}deg);'></div>
                            </div>
                            <div class='position-shadow'></div>
                          </div>
                        </div>
                      </div>`
                    } else {
                      message += `<div class='position-message-row'>
                        <div>Hành trình trực tiếp</div>
                        <div class='zlocation_desc'>Đã kết thúc</div>
                      </div>`
                    }

                    message += '</div></div>'
                    if (!(type === 'lastpin' || attachments.loading))
                      message = message.replace('class="img-message-row"', 'class="img-message-row" style="height:' + imgHeight + 'px;"')
                    if (type === 'desc') {
                      message = translate('Current Position')
                    }
                  }
                } catch (e) {
                  console.log(e)
                }
                break

              case 16:
                let stylecallgroup = ''
                if (zget(this.props, 'themeValue') === 'blueColor') {
                  stylecallgroup = '#fdf2ea'
                } else {
                  if (rxconfig.theme === 'galo') {
                    stylecallgroup = '#d4f5f1'
                  } else if (rxconfig.theme === 'default') {
                    stylecallgroup = '#e5efff'
                  }
                }

                let objCallStr = JSON.stringify({
                  group_id: objmsg.group_id,
                  message_id: objmsg.message_id
                })

                message = `<div class='zchat-callmess' style='background: ${stylecallgroup};'>
                  <div class='zchat-callname'>${translate('Call Group')}</div>`

                const time = Number(rxaget(attachments, 'stopped_at', 0)) - Number(rxaget(attachments, 'created_at', 0))
                message += `<div class='zchat-calltime'><i class='icon-call-in' style='color:#2fb13e;'></i>${secondToTime(time)}</div>`

                message += `<span class='zchat-callicon' onclick=window.onClickGroupCall(${objCallStr})><i class='icon-phone'></i></span></div>`
                if (type === 'desc') {
                  mess = translate(' finished')
                  message = call_name + mess
                }
                break
              case 17:
                let poll_type = attachments.poll_type
                let pollMess = ''
                switch (poll_type) {
                  case 2:
                    mess = translate(' have finished voting "') + attachments.question + '"'//+translate('" See')
                    pollMess = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                    break;
                  case 3:
                    if (attachments.isFirstVote) {
                      mess = translate(' participated in a new poll "') + attachments.question + '"'//+translate('" See')
                    } else {
                      mess = translate(' changed vote "') + attachments.question + '"'//+translate('" See')
                    }
                    pollMess = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                    break
                  case 4:
                    mess = translate(' just shared the a poll "') + attachments.question + '"'//+translate('" See')
                    pollMess = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {})) + mess
                    break
                  default:
                    break;
                }
                // pollMess = checkNameUser(rxaget(this.users, objmsg.sender_uin.toString(), {}), this.userid, this.user) + mess +  content
                message = `<div class='zchat-poll-row'  onclick=window.choosePoll(${JSON.stringify(attachments)},${objmsg.type})>` + pollMess + `<span class='zchat-poll-row-text'>${translate(" See")}</span></div>`

                break
              default:
                if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(this.userid) !== -1) {
                  message = this.getDeleteMessStr(objmsg, this.users, this.userid)
                } else {
                  let messagetmp = objmsg.message || ''
                  if (messagetmp && messagetmp.length < 50) {
                    let resMess = messagetmp.match(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g)
                    if (resMess && resMess.constructor === Array && resMess.length > 0) {
                      let uniemoji = [...new Set(resMess)]
                      for (let emoji of uniemoji) {
                        let regEmoji = new RegExp(emoji, 'g')
                        messagetmp = messagetmp.replace(regEmoji, '<span>' + emoji + '</span>')
                      }
                    }
                  }
                  messagetmp = this.convertUrlMess(objmsg, type)

                  if (objmsg && objmsg.message && zget(this.props, 'keywords', '') && zget(this.props, 'keywords', '').length > 2 && objmsg.message.toLowerCase().indexOf(zget(this.props, 'keywords', '').toLowerCase()) !== -1) {
                    let regex = new RegExp("(" + zget(this.props, 'keywords', '') + ")", "gi");
                    messagetmp = messagetmp.replace(regex, '<span class="zhighlight-chat">$1</span>')
                  }
                  if (objmsg && objmsg.message.indexOf('<') !== -1) {
                    messagetmp = objmsg.message.replace(/\</g, '&lt;')
                  }
                  if (messagetmp && messagetmp.indexOf('\\\\n') !== -1) {
                    messagetmp = messagetmp.replace(/\\\\n/g, 'BREAKLine')
                  }
                  if (messagetmp && messagetmp.indexOf('\\r\\n') !== -1) {
                    messagetmp = messagetmp.replace(/\\r\\n/g, '</br>')
                  }
                  if (messagetmp && messagetmp.indexOf('\\n') !== -1) {
                    // messagetmp = messagetmp.replace(/(?<!\\)\\n/g, '</br>')
                  }
                  if (messagetmp && messagetmp.indexOf('BREAKLine') !== -1) {
                    messagetmp = messagetmp.replace(/BREAKLine/g, '\\n')
                  }

                  if (messagetmp && messagetmp.lastIndexOf("\\r") !== -1) {
                    messagetmp = messagetmp.replace(/\\r$/g, "");
                  }
                  if (messagetmp && messagetmp.indexOf('\\t') !== -1) {
                    // messagetmp = messagetmp.replace(/(?<=[^\w\s]|^)\\t/g, ' ')
                  }
                  message = `<div class='zchat-textmess'>${messagetmp}</div>`
                }

                break
            }
          }
        } else {
          message = this.getDeleteMessStr(objmsg, this.users, this.userid)
        }
      } else {
        if (objmsg.status !== 4) {
          if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
            message = this.getDeleteMessStr(objmsg, this.users, this.userid)
          } else {
            message = objmsg.message || ''
          }
        } else {
          message = this.getDeleteMessStr(objmsg, this.users, this.userid)
        }
      }
      if (message.indexOf('@') !== -1) {
        let userstag = message.match(/(@\d+\b)/ig)
        if (userstag && userstag.constructor === Array && userstag.length > 0) {
          userstag.forEach(o => {
            let useridtmp = o.replace('@', '') || ''

            if (this.users[useridtmp]) {
              window[useridtmp] = this.users[useridtmp]
              let usernametmp = (this.users && this.users[useridtmp]) ? this.checkNameUser(this.users[useridtmp], 'tag') : ''
              message = objmsg.type === 6 ? message.replace(o, usernametmp)
                : message.replace(o, `<b onClick="window.showInfoUser('${useridtmp}')">${usernametmp}</b>`)
              // if (usernametmp && usernametmp && zget(this.props, 'keywords', '') && zget(this.props, 'keywords', '').length > 2 && usernametmp.toLowerCase().indexOf(zget(this.props, 'keywords', '').toLowerCase()) !== -1) {
              //   let regex = new RegExp("("+zget(this.props, 'keywords', '')+")", "gi");
              //   message = message.replace(regex, '<span class="zhighlight-chat">$1</span>')
              // }
            }
          })
        }
        message = message.replace(/\@All/g, '<b >@All</b>');
      }
      if (message.indexOf('[') !== -1) {
        message = message.replace(/\[b\]([\s\S]*?)\[\/b\]/g, '<span class="bbcode-bold">$1</span>')
        message = message.replace(/\[i\]([\s\S]*?)\[\/i\]/g, '<i>$1</i>')
        message = message.replace(/\[u\]([\s\S]*?)\[\/u\]/g, '<u>$1</u>')
      }

      // console.log(message, objmsg.type)
      return message
    } else {
      return ''
    }
  }

  getDeleteMessStr(objmsg, users, userid) {
    let user = ''
    if (userid.toString() === objmsg.sender_uin.toString()) {
      user = translate('You')
    } else {
      user = (users && users[objmsg.sender_uin.toString()]) ? this.checkNameUser(users[objmsg.sender_uin.toString()]) : (objmsg.sender_name) ? objmsg.sender_name : translate('Stranger')
    }
    let message = user + translate(' unsent a message')
    return message
  }

  convertUrlMess(objmsg, type) {
    if (objmsg.message) {
      let messagetmp = objmsg.message || ''
      if (messagetmp.indexOf('http') !== -1 && type !== 'pin_model') {
        try {
          let urls = messagetmp.match(/(\b(https?|http|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig)
          if (urls && urls.constructor && urls.length > 0) {
            let objReview = {
              uid: objmsg.group_id + '-' + objmsg.message_id,
              url: urls[0]
            }
            let objLink = rxaget(this.props, 'netaLink.data.' + objReview.uid, {})
            if (objLink && !objLink.uid) {
              if (window && window.ipcRenderer && !this.checkLink[objReview.uid]) {
                window.ipcRenderer.send('linkpreview', objReview)
              }
              this.checkLink[objReview.uid] = true

              for (let link of [...new Set(urls)]) {
                messagetmp = messagetmp.replace(link, `<span class='highlight_link' onclick=window.openExternalLink('${link}')>${link}</span>`)
              }

            } else {
              if (objLink.title !== '') {
                for (let link of urls) {
                  messagetmp = messagetmp.replace(link, `<span class='highlight_link' onclick=window.openExternalLink('${link}')>${link}</span>`)
                }
                const strmessagetmp = messagetmp
                const strtitle = subString(rxaget(objLink, 'title', ''), 80)
                const strdesc = subString(rxaget(objLink, 'description', ''), 100)

                messagetmp = `<div class='media_review'>
                  <div>${strmessagetmp}</div>
                  <div class='media_review_box' onclick=window.openExternalLink('${rxaget(objLink, 'url', '')}')>
                    <div class='review_box-title'>${strtitle}</div>
                    <div class='review_box-image'><img src='${(objLink.img) ? objLink.img : './images/tabs/default.jpg'}' alt='' class='review_box-img' /></div>
                    <div class='review_box-desc'>${strdesc}</div>
                  </div>
                </div>`
              }
            }

          }
        } catch (eurl) {
          console.log(eurl)
        }
      }
      return messagetmp

    }
  }

  convertOmessUser(omess) {
    let user = (this.users[omess.sender_uin]) ? this.users[omess.sender_uin] : {}
    return user
  }

  checkSticker(sticker, imgsticker) {
    let arrTabsDisplay = this.state.arrTabsDisplay
    for (let i = 0; i < arrTabsDisplay.length; i++) {
      if (arrTabsDisplay[i].type === sticker && arrTabsDisplay[i].data.indexOf(imgsticker) === -1) {
        return false
      }
    }
    return true
  }

  convertTagName(message) {
    let userstag = message.match(/(@\d+\b)/ig)
    if (userstag && userstag.constructor === Array && userstag.length > 0) {
      userstag.forEach(o => {
        let useridtmp = o.replace('@', '') || ''
        if (this.users[useridtmp]) {
          let usernametmp = this.checkNameUser(this.users[useridtmp])

          message = message.replace(o, '<b onClick="ClickInfoUser(' + useridtmp + ',' + this.userid + ',' + '' + ')">' + usernametmp + '</b>')
        }

      })
    }
    return message
  }

  checkNameUser(user, type) {
    let userName = (user.full_name) ? user.full_name : (user.phone) ? (user.phone) : ''
    // if (type === 'tag') {
    return userName || translate('Stranger')
    // } else {
    // return (userName) ? userName : (this.currentMsg && this.currentMsg.sender_uin !== this.userid.toString()) ? this.currentMsg.sender_name : translate('Stranger')
    // }
  }

  reactionsTemplate(reactions, currentMsg) {

    let template = <div className='reaction_emoji'>
      {!this.state.onOffBgEmoji && <div className='droped_popup_screen_bg' onClick={this.onClickBg}></div>}
      {reactions.map((emo, index) => emo.cnt > 0
        && REACTIONS[emo.type]
        && <div key={`${emo.type}-${index}`}
          className={`reaction_choose_emoji ${(this.state.currentEmoTypeClicked == emo.type
            && this.props.currentMessageIdClicked == currentMsg.message_id) ? 'bg_reaction' : ''}`}
          onClick={() => this.onClickTypeEmoji(emo.type, currentMsg.message_id)}
        >
          {
            !this.state.onOffBgEmoji
            && this.state.currentEmoTypeClicked === emo.type
            && this.props.currentMessageIdClicked == currentMsg.message_id
            && <RxChooseTypeEmoji key={`${emo.type}-${index}`} users={this.props.users} typeDropEmo={emo.type} groupId={this.props.group_id} messId={currentMsg.message_id}

            />
          }
          {REACTIONS[emo.type]}
          {emo.cnt < 9
            ? (emo.cnt > 1 ? <span className='reaction_cnt'>{emo.cnt}</span> : '')
            : <span className='reaction_cnt'>{'9+'}</span>
          }
        </div>
      )}
    </div>


    return template

  }

  getPollById(poll_id) {
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.props.token }
    fetch(global.rxu.get(global.rxu.config, 'api_get_poll') + poll_id, {
      method: 'GET',
      body: null,
      headers: headers
    })
      .then((res) => { return res.json() })
      .then((pollInfo) => {
        return pollInfo
      }).catch(er => console.log(er))
    // return {}
  }

  async getPollItem(poll_id, group_id) {
    let polls = await chatDB.polls.get({ group_id: group_id })
    let pollItem
    if (polls) {
      let pollsArr = polls.data
      pollItem = pollsArr.find(o => o.poll_id === poll_id)
    }
    return pollItem
  }

  async choosePoll(attachments, type) {
    let group_id = this.props.group_id
    let pollInfo

    if (type === 17) {
      pollInfo = await this.getPollItem(attachments.poll_id, group_id)
    } else if (type === 6 && attachments.pin_message && attachments.pin_message.type === 17) {
      let attach_mess = attachments.pin_message.message
      let attachments_poll = attach_mess.attachments
      pollInfo = await this.getPollItem(attachments_poll?.poll_id, group_id)
    } else if (type === 6 && attachments.unpin_message && attachments.unpin_message.type === 17) {
      let attach_mess = attachments.unpin_message.message
      let attachments_poll = attach_mess.attachments
      pollInfo = await this.getPollItem(attachments_poll?.poll_id, group_id)
    }
    if (pollInfo) {
      this.props.choosePoll(pollInfo)
    } else {
      alert(translate('Poll has been deleted'))
    }

  }

  isDeletedMess(objmsg) {
    const userid = this.userid.toString() || this.props.userid.toString()
    if (objmsg.status === 4) {
      return true
    } else if (objmsg.deleted_uins && objmsg.deleted_uins.constructor === Array && objmsg.deleted_uins.length > 0 && objmsg.deleted_uins.indexOf(userid) !== -1) {
      return true
    }
    return false
  }

  getMessTextClass() {

  }

  render() {
    const occupants_uins = rxaget(this.props, 'group.occupants_uins', [])
    const currentMsg = this.props.currentMsg || {}
    this.currentMsg = currentMsg
    let params = {
      status: currentMsg.status,
      type: currentMsg.type,
      sender_uin: currentMsg.sender_uin
    }
    const lastSeenMessObj = this.props.lastSeenMessObj
    const group_id = this.props.group_id
    let lastSeenMessId = ''
    const { reactions } = this.props
    if (lastSeenMessObj && group_id && lastSeenMessObj[group_id]) {
      lastSeenMessId = lastSeenMessObj[group_id].lastSeenMessId
    }
    // let flagDeleteMess = false

    // if (this.props.arr[this.props.index-1] && this.props.arr[this.props.index-1]['status'] === 4) {
    //   flagDeleteMess = true
    // }
    let flagSeen = false
    if (this.lastSeenMessId && currentMsg.message_id && Number(this.lastSeenMessId) >= Number(currentMsg.message_id)) {
      flagSeen = true
    }
    if (currentMsg && [2, 3, 4, 12].indexOf(currentMsg.type) !== -1 && currentMsg.attachments && currentMsg.attachments.indexOf('loading') !== -1) {
      flagSeen = false
    }

    let flagShow = currentMsg.sender_uin && ((this.props.index > 0 && currentMsg.sender_uin !== this.props.arr[this.props.index - 1].sender_uin) || this.props.index === this.props.firstMessageIndex || this.props.isShowUserName5Minute) && ((this.props.userid.toString() !== currentMsg.sender_uin.toString())) //(this.props.occupants_uins && this.props.occupants_uins.length > 2) && 
    return (
      <div>
        {([-1, 5, 6, 7, 17].indexOf(currentMsg.type) === -1) && <div>
          {this.props.flagShowAva && <div className='zmessage_colava'>
            <div className='zmessage_avasender' style={{ background: `${(currentMsg.group_type === 3) ? changeColorAva(rxaget(currentMsg, 'sender_uin', rxaget(currentMsg, 'group_id'))) : changeColorAva(rxaget(currentMsg, 'sender_uin', ''))}` }} onClick={e => this.props.clickInfoUser(currentMsg.sender_uin)}>
              {checkAvatarSender(currentMsg, this.users) && <img src={global.rxu.config.cdn_endpoint + this.users[currentMsg.sender_uin.toString()].profile_url} alt=''
                data-id={'sender' + currentMsg.sender_uin}
                className={'ava-sender images-static'}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = './images/default/static/avadefault.svg'
                }} />
              }
              <span className='avatar-sender'>
                {textAva(rxChangeSlug(this.checkNameUser(this.convertOmessUser(currentMsg))))}
              </span>
            </div>
          </div>}
          <div className={checkIsOwner(currentMsg, this.props.userid) ? 'zmessage_content_right' : 'zmessage_content'}>
            <div className='zmessage_box'>
              <div className={(currentMsg.type === 0 || currentMsg.status === 4) ? (this.props.userid.toString() === currentMsg.sender_uin.toString())
                ? 'zmessage_text my_message' : 'zmessage_text another_message' : 'zmessage_text static_message'}>

                {(flagShow == true) && <div id='stsender_name' className={(currentMsg.type !== 0) ? (currentMsg.type === 9 ? ' zsender_name_type9 ' : 'zsender_name_basic mess_type0') : 'zsender_name_basic'} onClick={e => this.props.clickInfoUser(currentMsg.sender_uin)} >
                  {this.checkNameUser(rxaget(this.users, currentMsg.sender_uin, {})) || currentMsg.sender_name.toString()}
                </div>}

                <div className='another_message_box'>
                  {flagShow ?
                    <div className={currentMsg.type === 0 ? 'zbg_mess' : ''}>

                      <div dangerouslySetInnerHTML={{ __html: this.parseMessage(currentMsg) }} />
                    </div>
                    :
                    <div dangerouslySetInnerHTML={{ __html: this.parseMessage(currentMsg) }} />
                  }

                  {([8, 9].indexOf(currentMsg.type) === -1) && <div className='zmessage_time'> {timeConverter(currentMsg.created_at, 'minute')} </div>}
                </div>
              </div>

              {checkIsOwner(currentMsg, this.props.userid) && <div className='zmessage_seen' data-flag={currentMsg.flag_seen}>
                {(flagSeen) && <img className='zmessage_seen_icon filter_img_class' alt='readed-icon' src={changeColorSVG('./images/default/icons/readed-icon.svg')} />}
                {(!flagSeen) && <img className='zmessage_seen_icon filter_img_class' alt='readed-icon' src={changeColorSVG('./images/default/static/icon-checked.svg')} />}
              </div>}
              {/* {
                (
                  checkIsOwner(currentMsg, this.props.userid) &&
                  (
                    ( Number(currentMsg.message_id) <= Number(lastSeenMessId)) 
                    || occupants_uins.length < 2
                  )
                )         
                && <div className='zmessage_seen'>
                  <img className='zmessage_seen_icon filter_img_class' alt='readed-icon' src={changeColorSVG('./images/default/icons/readed-icon.svg')}/> 
                  </div>
              }
              {
                checkIsOwner(currentMsg, this.props.userid)                   
                && Number(currentMsg.message_id) > Number(lastSeenMessId)    
                && occupants_uins.length >= 2        
                && <div className='zmessage_seen'>
                  <img className='zmessage_seen_icon filter_img_class' alt='readed-icon' src={changeColorSVG('./images/default/static/icon-checked.svg')}/> 
                </div>
              } */}

              {reactions?.length > 0 && this.reactionsTemplate(reactions, currentMsg)}


            </div>
          </div>
        </div>}

        {([-1, 5, 7].indexOf(currentMsg.type) !== -1) && <div className={(currentMsg.type === -1) ? 'zchat_row_child-unread' : 'zchat_row_child'}> {this.parseMessage(currentMsg)} </div>}
        {([6].indexOf(currentMsg.type) !== -1 && currentMsg.attachments && currentMsg.attachments.indexOf('pin_message') === -1) && <div className={(currentMsg.type === -1) ? 'zchat_row_child-unread' : 'zchat_row_child'}> {this.parseMessage(currentMsg)} </div>}
        {([6].indexOf(currentMsg.type) !== -1 && currentMsg.attachments && currentMsg.attachments.indexOf('pin_message') !== -1) && <div className={(currentMsg.type === -1) ? 'zchat_row_child-unread' : 'zchat_row_child'}> <div dangerouslySetInnerHTML={{ __html: this.parseMessage(currentMsg) }} /></div>}
        {[17].indexOf(currentMsg.type) !== -1 && <div className={(currentMsg.type === -1) ? 'zchat_row_child-unread' : 'zchat_row_child'}> <div dangerouslySetInnerHTML={{ __html: this.parseMessage(currentMsg) }} /></div>}

      </div>
    )
  }
}

export default MessageItem